<template>
  <div class="main_complete_home">
    <div style="background:#0072ff;height:60px;">
        <h1 style="font-size:25px;color:white;text-align:center;line-height:60px;">
            完善订单信息
        </h1>
    </div>
    <div class="main_complete_edit_content">
        <a-spin tip="加载中..." style="width:100%;text-align:center;margin-top:20px;margin-bottom:20px;" :spinning="loading">
        </a-spin>
        <ul style="display:grid;margin:0;padding:0;" :style="{'display':loading?'none':'block'}">
            <li style="width:100%;height:50px;">
                <a-input addon-before="车牌号" ref="userOrigPasswordInput" placeholder="请输入车牌号" v-model="auto.license_plate" style="width:100%;height:50px;margin-top:20px;font-size:20px;">
                    <a-icon type="user" />
                </a-input>
            </li>
            <li style="width:100%;height:80px;margin-top:20px;">
                <a-input addon-before="车型" ref="userOrigPasswordInput" placeholder="请输入车型" v-model="auto.model" style="width:100%;margin-top:20px;font-size:20px;">
                    <a-icon type="user" />
                </a-input>
                <span style="margin-left:10px;margin-top:10px;display:block;">例如：宝马X6</span>
            </li>
            <li style="width:100%;height:50px;margin-top:20px;">
                <a-input addon-before="VIN(车架号)" ref="userOrigPasswordInput" placeholder="请输入VIN(车架号)" v-model="auto.vin_no" style="width:100%;height:50px;margin-top:20px;font-size:20px;">
                    <a-icon type="user" />
                </a-input>
            </li>
            <li style="width:100%;height:50px;margin-top:20px;">
                <a-input addon-before="表里程显示" ref="userOrigPasswordInput" placeholder="请输入表里程显示" v-model="auto.meter_mileage" style="width:100%;height:50px;margin-top:20px;font-size:20px;">
                    <a-icon type="user" />
                </a-input>
            </li>
            <li style="width:100%;height:90px;margin-top:20px;">
                <span style="text-align:left;width:100%;display:block;margin-top:20px;font-size:16px;">检测类型</span>
                <a-radio-group :defaultValue="menu.mode" v-model="menu.mode" @change="onDetectModeChange($event)" style="margin:0;padding:0;margin-top:20px;">
                    <li style="float:left;">
                        <a-radio value="BASE">基础检测</a-radio>
                    </li>
                    <li style="float:left;">
                        <a-radio value="COMPREHENSIVE">全面检测</a-radio>
                    </li>
                    <li style="float:left;">
                        <a-radio value="EVALUATE">评估检测</a-radio>
                    </li>
                </a-radio-group>
            </li>
            <li style="width:100%;height:50px;margin-top:20px;">
                <a-input addon-before="联系人" ref="userOrigPasswordInput" placeholder="请输入联系人" v-model="customer.name" style="width:100%;height:50px;margin-top:20px;font-size:20px;">
                    <a-icon type="user" />
                </a-input>
            </li>
            <li style="width:100%;height:50px;margin-top:20px;">
                <a-input addon-before="联系方式" ref="userOrigPasswordInput" placeholder="请输入联系方式" v-model="customer.mobile" style="width:100%;height:50px;margin-top:20px;font-size:20px;">
                    <a-icon type="user" />
                </a-input>
            </li>
            <li style="width:100%;height:50px;margin-top:20px;">
                <a-input addon-before="身份证号" ref="userOrigPasswordInput" placeholder="请输入身份证号" v-model="customer.idcard_no" style="width:100%;height:50px;margin-top:20px;font-size:20px;">
                    <a-icon type="user" />
                </a-input>
            </li>
            <li style="width:100%;height:50px;margin-top:20px;">
                <a-input addon-before="检修师傅" ref="userOrigPasswordInput" placeholder="" :value="inspector.name ? inspector.name : inspector.username " style="width:100%;height:50px;margin-top:20px;font-size:20px;" disabled >
                    <a-icon type="user" />
                </a-input>
            </li>
            <li style="width:100%;height:80px;margin-top:20px;">
                <a-input addon-before="排量" type="number" ref="userOrigPasswordInput" placeholder="请输入排量" v-model="auto.displacement" style="width:100%;height:30px;margin-top:20px;font-size:20px;">
                    <a-icon type="user" />
                    <a-select slot="addonAfter" v-model="auto.displacement_unit" default-value="L" style="width: 60px">
                        <a-select-option value="L">
                            L
                        </a-select-option>
                        <a-select-option value="T">
                            T
                        </a-select-option>
                    </a-select>
                </a-input>
            </li>
            <li style="width:100%;height:50px;margin-top:20px;">
                <span style="margin-top:10px;display:block;font-size:16px;">变速箱</span>
                <a-select style="width: 120px;margin-top:15px;" v-model="auto.gearbox_type" :defaultValue="auto.gearbox_type" @change="handleGearBoxTypeChange($event)">
                    <a-select-option value="">
                        请选择...
                    </a-select-option>
                    <a-select-option value="AUTO">
                        自动
                    </a-select-option>
                    <a-select-option value="MANUAL">
                        手动
                    </a-select-option>
                </a-select>
            </li>
            <li style="width:100%;height:40px;margin-top:40px;">
                <a-input addon-before="注册地" ref="userOrigPasswordInput" placeholder="请填写注册地" v-model="registration_address" :value="registration_address" style="width:100%;height:50px;margin-top:20px;font-size:20px;" >
                    <a-icon type="user" />
                </a-input>
            </li>
            <li style="width:100%;margin-top:40px;">
                <span style="margin-top:10px;display:block;font-size:16px;">初登日期</span>
                <a-date-picker
                valueFormat="YYYY年MM月DD日"
                addon-before="初登日期" 
                placeholder="请输入初登日期" 
                :inputReadOnly="true"
                v-model="auto.first_boarding_date" 
                style="width:100%;height:70px;font-size:20px;line-height:70px;"
                >
                </a-date-picker>
            </li>
            <li style="width:100%;height:40px;">
                <a-input addon-before="车身颜色" ref="userOrigPasswordInput" placeholder="请填写车身颜色" v-model="auto.vehicle_color" style="width:100%;height:50px;margin-top:20px;font-size:20px;" >
                    <a-icon type="user" />
                </a-input>
            </li>
            <li style="width:100%;height:50px;margin-top:40px;">
                <span style="margin-top:10px;display:block;font-size:16px;">车辆用途</span>
                <a-select 
                style="width: 120px;margin-top:15px;" 
                v-model="auto.vehicle_use" 
                :defaultValue="auto.vehicle_use" 
                @change="handleVehicleUseChange($event)"
                >
                    <a-select-option value="">
                        请选择...
                    </a-select-option>
                    <a-select-option value="NON_OPERATION">
                        非运营
                    </a-select-option>
                    <a-select-option value="OPERATION">
                        运营
                    </a-select-option>
                    <a-select-option value="OPERATION_TO_NON">
                        营转非
                    </a-select-option>
                </a-select>
            </li>
            <li style="width:100%;height:50px;margin-top:40px;">
                <span style="margin-top:10px;display:block;font-size:16px;">使用性质</span>
                <a-select 
                style="width: 120px;margin-top:15px;" 
                v-model="auto.nature_of_use" 
                :defaultValue="auto.nature_of_use" 
                @change="handleNatureOfUseChange($event)"
                >
                    <a-select-option value="">
                        请选择...
                    </a-select-option>
                    <a-select-option value="PERSONAL">
                        个人
                    </a-select-option>
                    <a-select-option value="ENTERPRISE">
                        企业
                    </a-select-option>
                </a-select>
            </li>
            <li style="width:100%;height:50px;margin-top:40px;">
                <a-input 
                addon-before="发动机号" 
                ref="userOrigPasswordInput" 
                placeholder="请输入发动机号" 
                v-model="auto.engine_no" 
                style="width:100%;height:50px;margin-top:20px;font-size:20px;"
                >
                    <a-icon type="user" />
                </a-input>
            </li>
            <li style="width:100%;height:100px;margin-top:40px;">
                <span style="display:block;font-size:16px;">年检到期时间</span>
                <a-date-picker 
                valueFormat="YYYY年MM月DD日"
                :inputReadOnly="true"
                addon-before="年检到期时间" 
                placeholder="请输入年检到期时间" 
                v-model="auto.annual_inspection_expiration" 
                style="width:100%;line-height:70px;font-size:20px;"
                >
                </a-date-picker>
            </li>
            <li style="width:100%;height:50px;margin-top:20px;">
                <span style="margin-top:10px;display:block;font-size:16px;">国产/进口</span>
                <a-select style="width: 120px;margin-top:15px;" v-model="auto.vehicle_source" :defaultValue="auto.vehicle_source" @change="handleVehicleSourceChange($event)">
                    <a-select-option value="">
                        请选择...
                    </a-select-option>
                    <a-select-option value="DOMESTIC">
                        国产
                    </a-select-option>
                    <a-select-option value="IMPORT">
                        进口
                    </a-select-option>
                    <a-select-option value="JOINT_VENTURE">
                        合资车
                    </a-select-option>
                </a-select>
            </li>
            <li style="width:100%;height:50px;margin-top:40px;">
                <a-input addon-before="保障金额(数字)" type="number" ref="userOrigPasswordInput" placeholder="保障金额(数字)" v-model="auto.amount_of_protection_number" style="width:100%;height:50px;margin-top:20px;font-size:20px;">
                    <a-icon type="user" />
                </a-input>
            </li>
            <li style="width:100%;height:50px;margin-top:20px;">
                <a-input addon-before="保障金额(中文)" ref="userOrigPasswordInput" placeholder="保障金额(中文)" v-model="auto.amount_of_protection_zh" style="width:100%;height:50px;margin-top:20px;font-size:20px;">
                    <a-icon type="user" />
                </a-input>
            </li>
            <li style="width:100%;height:170px;margin-top:20px;">
                <span style="margin-top:10px;display:block;font-size:16px;">备注</span>
                <a-textarea 
                :autoSize=false
                ref="userOrigPasswordInput" placeholder="请输入备注" v-model="auto.remark" style="width:100%;height:150px;margin-top:20px;font-size:16px;">
                </a-textarea>
            </li>
            <li style="width:100%;height:50px;margin-top:40px;">
                <a-button
                :loading="update_loading"
                @click="update_order_click" 
                style="border-radius:5px;background:#1890ff;display:block;width:100%;height:50px;line-height:50px;margin-top:20px;color:white;font-size:20px;text-align:center;"
                >
                    保存
                </a-button>
            </li>
        </ul>
    </div>

    <div style="width:100%;height:50px;margin-top:50px;text-align:center;">
        <span style="line-height:50px;text-align:center;display:block;margin:0 auto;">
            {{ company.copyright_no }} 版权所有
        </span>
        <a style="text-align: center;width:100%;line-height: 20px;height:20px;display:block;" href="https://beian.miit.gov.cn" target="_blank">{{ company.record_no }}</a>
    </div>
  </div>
</template>

<script>

import order_model from '../../model/order'
import request from '../../api/request'
import colors from '../../model/colors'
import company_model from '../../model/company'
import options_model from '../../model/cities'
import watermark from 'watermark-dom'

export default {
    name: 'OrderComplete',
    head: {
        title: "完善订单信息",
        meta:[
            { name: 'description', content: '完善订单信息'}
        ]
    },
    data: function() {
        return {
            coversArgument: {
                id: 0,
                click_name: "点击上传",
                key: "avatar",
                accept: ".png, .jpg, .jpeg, .gif, .bmp",
                max_file_count: 99999999,
                unlimit_count: true,
                fileList: [],
            },
            order_id: "",
            order: order_model,
            mode:"",
            menu: {},
            auto: {},
            customer: {},
            inspector: {},
            predefineColors:colors.predefineColors,
            update_loading: false,
            registration_address:"",
            registration:[],
            company: company_model,
            options: options_model,
            loading: false,
        }
    },
    methods: {
        fetch_company() {
            let company_info_resp = request.company.company()
            company_info_resp.then((response) => {
                if (response.status == 200 && response.data.code == 0) {
                    if (response.data.data) {
                        this.company = response.data.data
                    }
                }
            })
        },
        load() {
            try {
                watermark.remove()
            }
            catch (err) {
                console.log()
            }
            this.fetch_company()
            this.order_id = this.$route.query.order_id
            this.fetchOrder()
        },
        fetchMenu(menu_identifier) { 
            var menu_detail_resp = request.order.menu_detail(menu_identifier)
            menu_detail_resp.then((response) => { 
                var failed_message = "获取套餐信息失败"
                if (response && response.status == 200 && response.data.code == 0) {
                    if (response.data && response.data.data) {
                        this.menu = response.data.data
                        this.loading = false
                    }
                    else {
                        this.$message.error(failed_message)
                    }
                }
                else {
                    this.loading = false
                    if (response.data && response.data.message) {
                        failed_message = response.data.message
                    }
                    this.$message.error(failed_message)
                }
            })
        },
        fetchInspector(inspector_identifier) { 
            var inspector_detail_resp = request.order.inspector_detail(inspector_identifier)
            inspector_detail_resp.then((response) => { 
                var failed_message = "获取检修师傅信息失败"
                if (response && response.status == 200 && response.data.code == 0) {
                    if (response.data && response.data.data) {
                        this.inspector = response.data.data
                        this.loading = false
                    }
                    else {
                        this.$message.error(failed_message)
                    }
                }
                else {
                    this.loading = false
                    if (response.data && response.data.message) {
                        failed_message = response.data.message
                    }
                    this.$message.error(failed_message)
                }
            })
        },
        fetchCustomer(customer_identifier) { 
            var customer_detail_resp = request.order.customer_detail(customer_identifier)
            customer_detail_resp.then((response) => { 
                var failed_message = "获取客户信息失败"
                if (response && response.status == 200 && response.data.code == 0) {
                    if (response.data && response.data.data) {
                        this.customer = response.data.data
                        this.loading = false
                    }
                    else {
                        this.$message.error(failed_message)
                    }
                }
                else {
                    this.loading = false
                    if (response.data && response.data.message) {
                        failed_message = response.data.message
                    }
                    this.$message.error(failed_message)
                }
            })
        },
        fetchAuto(auto_identifier) { 
            var auto_detail_resp = request.order.auto_detail(auto_identifier)
            auto_detail_resp.then((response) => { 
                var failed_message = "获取车辆信息失败"
                if (response && response.status == 200 && response.data.code == 0) {
                    if (response.data && response.data.data) {
                        this.auto = response.data.data
                        if (this.auto) {
                            this.registration_address = (this.auto.register_region && this.auto.register_region.address) ? this.auto.register_region.address : ''
                        }
                        if (this.auto.covers) {
                            var cover_dict = {}
                            for (var cover of this.auto.covers) {
                                if (cover.image_url) {
                                    cover_dict = {
                                        uid: String(this.auto.covers.indexOf(cover)),
                                        name: 'cover.png',
                                        status: 'done',
                                        url:cover.image_url,
                                    }
                                    this.coversArgument.fileList.push(cover_dict)
                                }
                            }
                            this.$forceUpdate()
                        }
                        this.loading = false
                    }
                    else {
                        this.$message.error(failed_message)
                    }
                }
                else {
                    this.loading = false
                    if (response.data && response.data.message) {
                        failed_message = response.data.message
                    }
                    this.$message.error(failed_message)
                }
            })
        },
        fetchOrder() {
            this.loading = true
            var order_detail_resp = request.order.detail(this.order_id)
            var failed_message = "获取订单信息失败"
            order_detail_resp.then((response) => {
                if (response && response.status == 200 && response.data.code == 0) {
                    if (response.data.data) {
                        this.order = response.data.data
                        var auto_id = this.order.auto_id
                        var menu_id = this.order.menu_id
                        var customer_id = this.order.customer_id
                        this.fetchAuto(auto_id)
                        this.fetchMenu(menu_id)
                        this.fetchCustomer(customer_id)
                    }
                    else {
                        this.$message.error(failed_message)
                    }
                }
                else {
                    if (response.data && response.data.message) {
                        failed_message = response.data.message
                    }
                    this.$message.error(failed_message)
                }
            })
            .catch((error) => {
                this.loading = false
                if (error) {
                    this.$error({
                        title: "请求失败，请联系管理员",
                        content: String(error),
                    });
                }
            })
            
        },
        update_order_click() {
            this.updateOrder()
        },
        updateOrder() {
            this.update_loading = true
            this.order.auto = this.auto
            this.order.customer = this.customer
            this.order.menu = this.menu
            var update_order_resp = request.order.update(this.order, this.registration, this.registration_address)
            update_order_resp.then((response) => {
                this.update_loading = false
                var failed_message = "更新订单信息失败"
                var success_message = "更新订单信息成功"
                if (response && response.status == 200 && response.data.code == 0) {
                    if (response.data && response.data.message) {
                        success_message = response.data.message
                    }
                    if (response.data.data) {
                        this.order = response.data.data
                        this.registration_address = (this.auto.register_region && this.auto.register_region.address) ? this.auto.register_region.address : ''
                    }
                    if (this.order && this.order.auto && this.auto.covers && this.auto.covers.length > 0) {
                        var index = 0
                        var cover = {}
                        var cover_dict = {}
                        this.coversArgument.fileList = []
                        for (index;index<this.auto.covers.length;index++) {
                            cover = this.auto.covers[index]
                            if (cover && cover.image_url) {
                                cover_dict = {
                                    uid: cover.identifier,
                                    name: 'cover.png',
                                    status: 'done',
                                    url:cover.image_url,
                                }
                                this.coversArgument.fileList.push(cover_dict)
                            }
                        }
                        this.$forceUpdate()
                    }
                    this.$router.go(-1)
                    this.$message.success(success_message)
                }
                else {
                    if (response.data && response.data.message) {
                        failed_message = response.data.message
                    }
                    this.$message.error(failed_message)
                }
            })
            .catch((error) => {
                this.update_loading = false
                if (error) {
                    this.$error({
                        title: "请求失败，请联系管理员",
                        content: String(error),
                    });
                }
            })
        },
        handleGearBoxTypeChange(value) {
            this.auto.gearbox_type = value
        },
        handleVehicleSourceChange(value) {
            this.auto.vehicle_source = value
        },
        handleVehicleUseChange(value) {
            this.auto.vehicle_use = value
        },
        handleNatureOfUseChange(value) {
            this.auto.nature_of_use = value
        },
        onDetectModeChange(value) {
            this.menu.mode = value.target.value
        }
    },
    created() {
        this.load()
    },
    components: {
    }
}
</script>

<style>

html {
  margin: 0;
  padding: 0;
}

body {
  margin: 0; 
  padding: 0;
}

ul {
  list-style: none;
}

.main_complete_home {
    margin: 0;
    padding: 0;
}

.main_complete_edit_content {
    margin: 0;
    padding: 0;
    margin-left: 5vw;
    margin-right: 5vw;
    margin-bottom: 0;
    margin-top: 30px;
}

.main_content > ul {
    margin: 0;
    padding: 0;
}

.edit_footer {
    background: #99999999;
    display: block;
    width: 100%;
    height: 50px;
    margin: 0;
    padding: 0;
}

.edit_footer span {
    padding: 0;
    margin: 0 auto;
    width: 100%;
    height: 100%;
    line-height: 50px;
}

</style>
